import { lazy } from 'react';

import { RouteItem } from '@/base/RenderRouter';

import LazyLoad from './lazyLoad';


export const normalRoutes: RouteItem[] = [
  {
    path: '/',
    redirect: '/im',
  },
  // IM 独立路由，不使用主布局，直接使用im.tsx模块
  ...require('./modules/im.tsx').default,
  {
    path: '/404',
    element: LazyLoad(lazy(() => import('@/pages/404/index'))),
    meta: {
      title: '404',
      key: 'noFound',
    },
  },
  {
    path: '*',
    redirect: '/404',
  },
];
